






























import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import { TbGrade } from '@/http';
@Component({
    components: {
      
    },
})
export default class vipGradePanel extends Vue {
    public $refs: {
    };
    columnsUnit= [];
    
    show = false;

    defaultIndex = 0;

    created() {
    }
    mounted() {
     
        
    }

    moveHandle() {}
    onClose(){
        this.show = false;
    }
    Confirm(value){
        this.$emit("vipGradeConfirm",value);
        this.show = false;
    }
   
    async showFun(val){
        await this.init();
        if(val){
            this.defaultIndex  = this.columnsUnit.findIndex(v=>v.id==val);
        }
        this.show = true;
    }

    async init(){
        let res = await TbGrade.GetGradeList();
        this.columnsUnit = res.map(v=>{
            return {
                ...v,
                nameDiscount:v.name=='普通会员'?v.name+'(无折扣)':v.name+`(${v.discount.toFixed(1)}折)`
            }
        });
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/vipGradePanel.vue